import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/product/:slug',
      name: 'product',
      component: Home
    },
    {
      path: '/*',
      name: 'Home',
      component: Home
    }
  ]
});
